import { useState, useCallback } from "react";
import type { UseFormReturn } from "react-hook-form";
import type { CommunicationFormValues } from "./communicationFormSchema";

export function useFollowUpSuggestion(
  form: UseFormReturn<CommunicationFormValues>,
  bodyValue: string
) {
  const [isSuggesting, setIsSuggesting] = useState(false);

  const handleFollowUpToggle = useCallback(
    async (checked: boolean) => {
      form.setValue("follow_up_schedule", checked);

      if (checked && bodyValue && bodyValue.length > 10) {
        setIsSuggesting(true);
        try {
          const response = await fetch("/api/ai/suggest-follow-up", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ notes: bodyValue }),
          });

          if (response.ok) {
            const suggestion = await response.json();
            if (suggestion.dueDate) {
              form.setValue("follow_up_due_date", new Date(suggestion.dueDate));
            }
            if (suggestion.quickNote) {
              form.setValue("follow_up_note", suggestion.quickNote);
            }
          }
        } catch (err) {
          console.error("AI suggestion failed:", err);
        } finally {
          setIsSuggesting(false);
        }
      }
    },
    [bodyValue, form]
  );

  return { handleFollowUpToggle, isSuggesting };
}
